import { Typography } from '@breetometer/components';
import { classNameMerger } from '@breetometer/utils';
import { NotificationBannerAlertIcon } from 'BreetAssets';

import type { IStandardNotification } from '../NotificationBanner.helpers';

export const StandardNotification = ({ message, status, mood }: IStandardNotification) => {
	if (!message) return null;

	const successStatus = status === 'success' ? 'bg-success-800' : 'bg-dark-maroon';
	const txtStatus = status === 'success' ? 'color-success-400' : 'color-light-coral-red';

	return (
		<div
			className={classNameMerger(
				'notificationbanner',
				status,
				mood === 'black-white' ? 'bg-primary-600 border-dark-navy' : successStatus,
				'standard',
				mood
			)}
			data-testid='notification-banner'
		>
			<NotificationBannerAlertIcon
				status={status}
				className={mood === 'black-white' ? 'svg-dark' : ''}
			/>
			<Typography className={classNameMerger(status, mood === 'black-white' ? 'color-primary-100' : txtStatus, mood)}>
				{message}
			</Typography>
		</div>
	);
};
